import { FC, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { IProjectUI } from 'data/types/project.types';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { isDemo } from 'utils/utils';
import Button from 'components/Base/Button';
import ManageProjectMemberModal from './ManageProjectMemberModal';

type TManageProjectMembersProps = {
  members: IProjectUI['members'];
  projectId: string;
  projectName: string;
  isMobileView: boolean;
};

const ManageProjectMembers: FC<TManageProjectMembersProps> = ({
  members,
  projectId,
  projectName,
  isMobileView,
}) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    if (isDemo) return;
    setOpen(true);
  };

  return (
    <>
      {isMobileView ? (
        <IconButton
          size="small"
          onClick={handleClickOpen}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'primary.light',
            },
          }}
        >
          <PeopleOutlineIcon />
        </IconButton>
      ) : (
        <Tooltip title={isDemo ? 'Unavailable for playground mode' : ''}>
          <Button
            variant="outlined"
            onClick={handleClickOpen}
            startIcon={<PeopleOutlineIcon />}
            sx={{
              borderColor: 'divider',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'primary.main',
                backgroundColor: 'primary.light',
              },
            }}
          >
            Manage people
          </Button>
        </Tooltip>
      )}
      {open && (
        <ManageProjectMemberModal
          currentMembers={members}
          open={open}
          setOpen={setOpen}
          projectId={projectId}
          projectName={projectName}
        />
      )}
    </>
  );
};

export default ManageProjectMembers;
